import React, { useEffect } from 'react';
import BicesterToolbar from '@/components/layouts/BicesterToolbar';
import useTabs from '@/hooks/useTabs';
import { RECEIPT_TABS } from './constants';
import useRouter from '@/hooks/useRouter';

const ReceiptContext = React.createContext(null);

const Receipt = ({ children }) => {
  const { pathname } = useRouter();

  const { tabs, activeTab, onChangeTab } = useTabs<string>([
    { label: '小票审核', key: RECEIPT_TABS.EXAMINE, url: '/receipt/examine' },
    { label: '上传小票', key: RECEIPT_TABS.UPLOAD, url: '/receipt/upload' },
  ]);

  useEffect(() => {
    const currentTab = tabs.find((tab) => pathname?.endsWith(tab.url));
    onChangeTab(currentTab?.key);
  }, [tabs, onChangeTab, pathname]);

  return (
    <div className="bicester-receipt">
      <BicesterToolbar>
        <BicesterToolbar.NavBar data={tabs} activeTab={activeTab} isActiveDefault />
      </BicesterToolbar>
      <ReceiptContext.Provider value={{}}>{children}</ReceiptContext.Provider>
    </div>
  );
};

export default Receipt;
